export class StoreSwitcher extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.selectedCountry = null

    this.triggerButton = this.els.trigger.element
    this.triggerText = this.els['trigger-text'].element
    this.dropdown = this.els.dropdown.element
    this.menu = this.els.menu.element
    this.applyButton = this.els.apply.element

    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.onSelection = this.onSelection.bind(this)
    this.applyChanges = this.applyChanges.bind(this)

    this.listeners.add(this.triggerButton, 'click', this.toggleDropdown)
    this.els.item.elements.forEach((el) => {
      this.listeners.add(el, 'click', this.onSelection)
    })
    this.listeners.add(this.applyButton, 'click', this.applyChanges)
  }

  toggleDropdown () {
    const isExpanded =
      this.triggerButton.getAttribute('aria-expanded') === 'true'
    this.dropdown.classList.toggle(
      'drw-StoreSwitcher_Dropdown-expanded',
      !isExpanded,
    )
    this.triggerButton.setAttribute('aria-expanded', !isExpanded)
    this.menu.hidden = isExpanded
  }

  onSelection (e) {
    if (!e.currentTarget.matches(this.els.item.selector)) return

    const target = e.currentTarget

    const countryCode = target.dataset.countryCode

    this.selectedCountry = countryCode

    this.applyButton.disabled = false

    this.triggerText.textContent = target.textContent

    this.els.item.elements.forEach((el) => {
      el.removeAttribute('aria-current')
    })

    target.setAttribute('aria-current', 'true')

    this.toggleDropdown()
  }

  applyChanges () {
    if (!this.selectedCountry) return

    const form = this.querySelector('form')

    const val = document.createElement('input')
    val.setAttribute('type', 'hidden')
    val.setAttribute('name', 'country_code')
    val.setAttribute('value', this.selectedCountry)

    form.appendChild(val)

    form.submit()
  }
}

if (!customElements.get('store-switcher')) {
  customElements.define('store-switcher', StoreSwitcher)
}
